import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';

import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';


import themeConfig from '../theme-config';
import { setContext } from '../redux/actions/authActions';
import store from '../store';
import { SHOW_LOADING } from '../redux/actions/types/loadingTypes';

const styles = theme => ({

  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },

  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});

class ContextPage extends React.Component {
  constructor(props) {

    super(props);

    this.state = {
      program: '',
    };

    this.goToDashboard = this.goToDashboard.bind(this);

  }

  componentWillMount() {

    const { user } = this.props;

    if (user.LstCompany.length === 1) this.setCompany(user.LstCompany[0]);

  }

  componentDidMount() {

    const { user, history } = this.props;
    if (!user) history.push('/login');

  }

  renderCompany = company => (
    <FormControlLabel
      value={company}
      control={<Radio color="primary" />}
      label={company.name}
      onClick={() => this.setCompany(company)}
    />)

  handleChange = (event) => {

    this.setState({ value: event.target.value });

  };

  setCompany = (company) => {

    this.setState({ company });

  }

  goToDashboard() {

    const { user, setContext, history } = this.props;
    const { company } = this.state;
    const newuser = user;
    newuser.context = company;

    store.dispatch({
      type: SHOW_LOADING,
    });

    setContext(newuser);
    history.push('/dashboard');

  }


  render() {


    const { company } = this.state;
    const { classes, loading, user } = this.props;

    return (
      <div>

        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <center>
              <img style={{ width: '100%' }} src={themeConfig.logo} alt="logo" />
            </center>
            <form className={classes.form}>
              <dl>
                {user

                 && (
                 <RadioGroup
                   aria-label="company"
                   name="company"
                   value={company}
                 >
                   {user.LstCompany.map(this.renderCompany)}
                 </RadioGroup>
                 )

               }
              </dl>

              <Button
                type="submit"
                fullWidth
                variant="raised"
                color="primary"
                onClick={this.goToDashboard}
                className={classes.submit}
                disabled={!company}
              >
                {I18n.t('button.login')}
              </Button>

            </form>
          </Paper>
        </main>
      </div>

    );

  }


}


ContextPage.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.appReducer.loading,
});

const mapDispatchToProps = {
  setContext,
};


const connectedContainer = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContextPage));
const RoutedContainer = withRouter(connectedContainer);
export default RoutedContainer;



// WEBPACK FOOTER //
// ./src/containers/contextPage.js